// pdf-config.ts

import pdfMake from 'pdfmake/build/pdfmake';
import { BinaryFontsService } from './binary-fonts.service';

export function setUpPdfMake(binaryFontsService: BinaryFontsService): void {
  (pdfMake as any).vfs = binaryFontsService.fonts;
  (pdfMake as any).fonts = {
    Font: {  // Add this key
      normal: 'Merriweather-Light.ttf',
      bold: 'Merriweather-Regular.ttf',
      italics: 'Merriweather-Light.ttf',
      bolditalics: 'Merriweather-Light.ttf'
    },
    GT: {
      normal: 'Merriweather-Light.ttf',
      bold: 'Merriweather-Regular.ttf',
      italics: 'Merriweather-Light.ttf',
      bolditalics: 'Merriweather-Light.ttf'
    },
  };
}

/**
 * Hier bauen wir das docDefinition-Objekt zusammen:
 * - content: Das Array mit deinen Hauptinhalten
 * - logoSettings: enthält die Position x, y, Breite und das SVG
 * - sidebarActive: flag, ob Sidebar aktiv ist (um pageMargins zu steuern)
 * - headerContent: Array mit deinen Header-Texten (z.B. Produkt- und Report-Titel)
 */
export function createDocDefinition(
  content: any[],
  logoSettings: any,
  sidebarActive: boolean,
  headerContent: any,
  logoOptiroi: any
): any {

  // Passe die Seitenränder an, wenn eine Sidebar existiert.
  const customMargin = sidebarActive
    ? [20, 70, 20, 40]
    : [20, 20, 20, 20];

  return {
    // 1) Header-Funktion sorgt dafür, dass der Inhalt auf jeder Seite erscheint:
    header: function(currentPage: number, pageCount: number) {
      // Wir geben ein Array zurück, damit wir das Logo (absolut positioniert)
      // + dein "headerContent"-Array (mit Text etc.) kombiniert darstellen können.
      if (headerContent.name.toLowerCase().startsWith('optiroi')) {
        return {
          columns: [
            {
              svg: logoSettings.svg,
              width: logoSettings.width,
              absolutePosition: { x: logoSettings.x, y: logoSettings.y }
            },
            { text: headerContent.title, style: 'header', margin: [110, 25, 0, 0] },
            {
              image: logoOptiroi,
              width: 90,
              absolutePosition: { x: 480, y: 25 }
            }
          ]
        };
      } else {
        // Standard-Header, falls kein "optiroi" vorliegt:
        return [
          {
            svg: logoSettings.svg,
            width: logoSettings.width,
            absolutePosition: { x: logoSettings.x, y: logoSettings.y }
          },
          { text: headerContent.title, style: 'header', margin: [150, 25, 0, 0] }
        ];
      }
    },

    // 2) Der reguläre Inhalt:
    content: content,

    // 3) Standard-Stile
    defaultStyle: {
      font: 'GT',
      fontSize: 7.5,
      color: '#1F273C',
      lineHeight: 1.2,
    },

    // 4) Seitenränder (abhängig vom sidebarActive-Flag)
    pageMargins: customMargin,

    // 5) Eigene Styles, die du in deinem Header/Text verwenden kannst
    styles: {
      header: {
        fontSize: 9,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      headerSmall: {
        fontSize: 7.5,
        bold: true,
        margin: [0, 15, 0, 5]
      },
      paragraph: {
        margin: [0, 0, 0, 5]
      },
      listItem: {
        margin: [0, 0, 0, 0]
      },
      orderedList: {
        margin: [0, 0, 0, 0]
      },
      unorderedList: {
        margin: [0, 0, 0, 0]
      }
    },

    // 6) Footer-Funktion. Hier hast du bereits dein Seitenzahlen-Beispiel
    footer: (currentPage: number, pageCount: number) => {
      if (sidebarActive) {
        const leftFooterText = 'Dr. Blumer & Partner AM AG\nLandstrasse 8\n9496 Balzers\nLiechtenstein';
        return {
          columns: [
            {
              text: leftFooterText,
              alignment: 'left',
              width: '70%',
              fontSize: 7,
              margin: [10, 0, 0, 0]
            },
            {
              text: `Page ${currentPage} of ${pageCount}`,
              alignment: 'right',
              fontSize: 7,
              margin: [0, 20, 20, 0]
            }
          ],
          margin: [0, 0, 0, 0]
        };
      } else {
        const leftFooterText = 'Dr. Blumer & Partner Asset Management AG, Landstrasse 8, 9496 Balzers, Liechtenstein';
        return {
          columns: [
            {
              text: leftFooterText,
              alignment: 'left',
              width: '70%',
              fontSize: 7,
              margin: [20, 0, 0, 0]
            },
            {
              text: `Page ${currentPage} of ${pageCount}`,
              alignment: 'right',
              fontSize: 7,
              margin: [0, 0, 20, 0]
            }
          ],
          margin: [0, 0, 0, 0]
        };
      }
    }
  };
}
